import { Permission } from './permissions.const';

export enum RoleEnum {
  Admin = 'Admin',
  Driver = 'Driver',
  Lead = 'Leader',
  Engineer = 'Engineer',
  Manager = 'Manager',
}

// 角色显示名称映射
export const ROLE_DISPLAY_NAMES: Record<RoleEnum, string> = {
  [RoleEnum.Admin]: 'Administrator',
  [RoleEnum.Manager]: 'Manager',
  [RoleEnum.Engineer]: 'Engineer',
  [RoleEnum.Lead]: 'Team Leader', 
  [RoleEnum.Driver]: 'Driver',
};

export const ROLE_DISPLAY_NAMES_ZH: Record<RoleEnum, string> = {
  [RoleEnum.Admin]: '管理员',
  [RoleEnum.Manager]: '经理',
  [RoleEnum.Engineer]: '工程师',
  [RoleEnum.Lead]: '团队领导', 
  [RoleEnum.Driver]: '司机',
};

// 角色优先级（数字越小优先级越高）
export const ROLE_PRIORITY: Record<RoleEnum, number> = {
  [RoleEnum.Admin]: 1,
  [RoleEnum.Manager]: 2,
  [RoleEnum.Engineer]: 3,
  [RoleEnum.Lead]: 4,
  [RoleEnum.Driver]: 5,
};

export const ROLE_PERMISSIONS_MAP: Record<string, Permission[]> = {
  [RoleEnum.Admin]: [
    Permission.USER_CREATE,
    Permission.USER_REMOVE,
    Permission.USER_OBSOLETE,
    Permission.FLEET_CREATE,
    Permission.FLEET_READ,
    Permission.FLEET_UPDATE,
    Permission.FLEET_DELETE,
    Permission.FLEET_LIST_ALL,
    Permission.FLEET_ASSIGN,
    Permission.INSPECTION_CREATE,
    Permission.INSPECTION_READ,
    Permission.INSPECTION_DELETE,
    Permission.INSPECTION_UPDATE,
    Permission.INSPECTION_LIST_FLEET_REPORTS,
    Permission.REPORTS_MANAGE,
    Permission.DEVIATION_CREATE,
    Permission.DEVIATION_CREATE_PRODUCT,
    Permission.DEVIATION_CREATE_OPERATION,
    Permission.DEVIATION_READ,
    Permission.DEVIATION_DELETE,
    Permission.DEVIATION_UPDATE,
  ],
  [RoleEnum.Driver]: [
    Permission.FLEET_READ,
    Permission.INSPECTION_CREATE,
    Permission.INSPECTION_READ,
    Permission.INSPECTION_UPDATE,
    Permission.DEVIATION_CREATE,
    Permission.DEVIATION_CREATE_PRODUCT,
    Permission.DEVIATION_CREATE_OPERATION,
    Permission.DEVIATION_READ,
    Permission.DEVIATION_UPDATE,
  ],
  [RoleEnum.Lead]: [
    Permission.FLEET_CREATE,
    Permission.FLEET_READ,
    Permission.FLEET_UPDATE,
    Permission.FLEET_DELETE,
    Permission.FLEET_LIST_ALL,
    Permission.FLEET_ASSIGN,
    Permission.INSPECTION_READ,
    Permission.INSPECTION_UPDATE,
    Permission.INSPECTION_LIST_FLEET_REPORTS,
    Permission.REPORTS_MANAGE,
    Permission.DEVIATION_READ,
    Permission.DEVIATION_UPDATE,
  ],
  [RoleEnum.Engineer]: [
    Permission.FLEET_READ,
    Permission.FLEET_LIST_ALL,
    Permission.INSPECTION_READ,
    Permission.INSPECTION_LIST_FLEET_REPORTS,
    Permission.REPORTS_MANAGE,
    Permission.DEVIATION_READ,
    Permission.PRODUCT_INFO_UPLOAD,
  ],
  [RoleEnum.Manager]: [
    Permission.FLEET_READ,
    Permission.FLEET_LIST_ALL,
    Permission.INSPECTION_READ,
    Permission.INSPECTION_LIST_FLEET_REPORTS,
    Permission.REPORTS_MANAGE,
    Permission.DEVIATION_READ,
    // Permission.PRODUCT_INFO_UPLOAD,
  ],
};

export function getPermissionsByRole(role: RoleEnum): Permission[] {
  return ROLE_PERMISSIONS_MAP[role] || [];
}

export function getRolesByPermission(permissionList: Permission[]): RoleEnum[] {
  // 如果没有权限要求，返回所有角色
  if (!permissionList || permissionList.length === 0) {
    return Object.values(RoleEnum);
  }
  
  const roles: RoleEnum[] = [];
  for (const role in ROLE_PERMISSIONS_MAP) {
    const rolePermissions = ROLE_PERMISSIONS_MAP[role];
    const hasAllPermissions = permissionList.every(permission => rolePermissions.includes(permission));
    if (hasAllPermissions) {
      roles.push(role as RoleEnum);
    }
  }  
  return roles;
} 